module.exports = __webpack_public_path__ + "static/media/Mostafa.38b5177f.png";